import React from "react"
import styled from "styled-components"
import { Field, FieldProps } from "react-final-form"
import { FontConfigurations, typography } from "theme"

import {
  DefaultField,
  DefaultFieldProps,
  chainValidators,
  getValidator,
  validateEmailFormat,
  validatePasswordFormat
} from "components/form"
import { INPUT_CSS } from "components/form/shared/default-field/styles"

const TextInput = styled.input.attrs({
  ...FontConfigurations.p
})`
  ${INPUT_CSS}
  ${typography}
`

export function TextInputField(props: FieldProps<string, HTMLInputElement>) {
  let validate = getValidator(props.validate, props.required)

  if (props.type === "email") {
    validate = chainValidators(validate, validateEmailFormat)
  } else if (props.type === "password") {
    validate = chainValidators(validate, validatePasswordFormat)
  }

  return (
    <Field InputComponent={TextInput} {...props} validate={validate}>
      {(inputProps: DefaultFieldProps<string>) => <DefaultField {...inputProps} />}
    </Field>
  )
}
